<!-- Search Header Section -->
<div class="search-header">
  <div class="search-input-wrapper">
    <mat-form-field appearance="outline" color="primary" class="hide-hint w-100 search-dialog-field">
      <span matPrefix class="search-dialog-prefix" aria-hidden="true">
        <mat-icon>search</mat-icon>
      </span>
      <input matInput [placeholder]="'header.search_placeholder' | translate" [formControl]="searchControl" autofocus />
    </mat-form-field>
    <button mat-icon-button mat-dialog-close class="close-btn">
      <span class="d-flex justify-content-center align-items-center">
        <mat-icon>close</mat-icon>

      </span>
    </button>
  </div>
</div>

<!-- Results Section -->
<div class="search-content">
  @if (!searchControl.value || searchControl.value.trim() === '') {
  <!-- Initial state: show recent searches -->
  <div class="empty-state">
    @if (recentSearches.length > 0) {
    <div class="recent-searches">
      <div class="recent-header">
        <p class="recent-title">{{ 'header.recent_searches' | translate }}</p>
        <button mat-button class="clear-history-btn" (click)="clearAllHistory()">
          <span>{{ 'header.clear_history' | translate }}</span>
        </button>
      </div>
      <div class="recent-items">
        @for(search of recentSearches; track search.timestamp) {
        <button class="recent-item" (click)="selectRecentSearch(search.query)">
          <i-tabler name="history"></i-tabler>
          <div class="recent-item-content">
            <span class="recent-item-query">{{ search.query }}</span>
            <span class="recent-item-count">{{ search.resultCount }} {{ 'header.results' | translate }}</span>
          </div>

          <button mat-icon-button class="delete-item-btn" (click)="removeRecentSearch($event, search.query)">
            <span class="d-flex justify-content-center align-items-center">
              <mat-icon>delete</mat-icon>
            </span>
          </button>
        </button>
        }
      </div>
    </div>
    } @else {
    <i-tabler name="search" class="empty-icon search-initial"></i-tabler>
    <p class="empty-text">{{ 'header.search_placeholder' | translate }}</p>
    <p class="empty-subtext">{{ 'header.search_hint' | translate }}</p>
    }
  </div>
  } @else {
  @let results = (filteredResults$ | async);
  @if (results && results.length > 0) {
  <!-- Results found -->
  <div class="results-container">
    <h4 class="results-title">{{ 'header.quick_links' | translate }} ({{ results.length }})</h4>

    <div class="items-grid">
      @for(item of results; track item.displayName) {
      <a [routerLink]="[item.route]" mat-dialog-close class="nav-item-card">
        <div class="item-icon-wrapper">
          @if (item.iconName) {
          <i-tabler [name]="item.iconName" class="item-icon"></i-tabler>
          }
        </div>
        <div class="item-content">
          <h5 class="item-title">
            {{ ('side_menu.' + item.displayName) | translate }}
          </h5>
          <span class="item-route">{{ (item.shortDescription) | translate }}</span>
        </div>
        <i-tabler name="info-circle" class="item-info-btn" [matTooltip]="(item.Description) | translate"
          matTooltipPosition="left" (click)="$event.stopPropagation()"></i-tabler>
        <div class="item-arrow">
          <i-tabler name="chevron-right"></i-tabler>
        </div>
      </a>
      }
    </div>
  </div>
  } @else {
  <!-- No results found -->
  <div class="empty-state">
    <i-tabler name="search-off" class="empty-icon"></i-tabler>
    <p class="empty-text">{{ 'header.no_results' | translate }}</p>
  </div>
  }
  }
</div>